import './style.css';
import UmapComponent from "./Components/UMAPComponent";
import UmapComponentColorBy from "./Components/UmapComponentColorBy";
import UmapFocusComponent from "./Components/UMAPFocusComponent";
import TableComponent from "./Components/TableComponent";
import TableUserData from "./Components/TableUserData";
import StarplotComponent from "./Components/StarplotComponent";
import ConfigureComponent from './Components/ConfigureComponent';
import ProjectionsComponent from './Components/ProjectionsComponent';
import HistogramComponent from './Components/HistogramComponent';
import BoxplotComponent from './Components/BoxplotComponent';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import CSVReader from 'react-csv-reader';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Formfield from 'preact-material-components/FormField';
import Checkbox from "@material-ui/core/Checkbox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { BsInfoCircleFill } from "react-icons/bs";
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from "react-bootstrap/Image";
import { Component } from 'preact';
import * as d3 from 'd3';
import ListGroup from 'react-bootstrap/ListGroup';

export default class App extends Component {

constructor(){
	super()
  this.state = {
		optionDropDown : -1, //opcion seleccionada del dropdownbutton umap
		titleDropDown:"Cationes+Coc+Oxides",
		colorbyTitle:"Attribute",
		colorbyAttributeTitle:"Ti",
		attributesLabels:[],
		attributesOptions:[],
		selectedAttribute:0,
		umap_data: [],//data para dibujar el UMAP - data[0] umap cocTi, data[1] umap TiO2, data[2] umap end-memb
		umap_detrital:[],
    complete_data: [],  //data total con los elementos quimicos, categorias y subcategorias por muestra
    detrital_data:[],
		filteredData_panel: [], //data "seleccionada" en Configure
		filteredData_umap: [], //data "seleccionada" en UMAP
		filteredData_detrital:[],
		show:false,
		filteredData_projection: [], //data "resaltada" en Table/Projections
		selecc_category:[],
		active:true,
		view_contours:false,
		loading:false
  }
  this.update_filteredData_panel = this.update_filteredData_panel.bind(this);
	this.update_filteredData_umap = this.update_filteredData_umap.bind(this);
	this.update_filteredData_projection  = this.update_filteredData_projection.bind(this);
	this.update_filtered_detrital_data = this.update_filtered_detrital_data.bind(this);
	this.update_labelsCategory = this.update_labelsCategory.bind(this);
	this.clkSeleccDetrital =  this.clkSeleccDetrital.bind(this);
	this.handleOpen = this.handleOpen.bind(this);
	this.handleClose = this.handleClose.bind(this);
	this.deleteDetrital = this.deleteDetrital.bind(this);
	this.selectColorBy = this.selectColorBy.bind(this);
	this.selectColorByAttribute = this.selectColorByAttribute.bind(this);
	this.onSelect_dropdown = this.onSelect_dropdown.bind(this);
}

/**
 * Se invoca antes de que se monte el componente.
 * Carga los datos para dibujar el UMAP y los datos totales de muestras
 */

componentWillMount() {
  let data_file = [];
  //let files_name=['assets/data/cocientes+cocTi_75_0.25.csv','assets/data/cocientes+TiO2_75_0.25.csv','assets/data/endmembers_75_0.25.csv'];
	let files_name=['static/assets/data/cocientes+cocTi_75_0.25.csv','static/assets/data/endmembers_75_0.25.csv'];
	//let files_name=['assets/data/cocientes+cocTi_75_0.25.csv','assets/data/endmembers_75_0.25.csv'];

  for(let i = 0; i<files_name.length;i++){
    let d = [];
    d3.csv(files_name[i]).then(function(data) {
      for(let j = 0; j<data.length; j++){
        d.push({
          i:j,
          umap1: +data[j].umap1,
          umap2: +data[j].umap2,
					Category:data[j].cat
        })
      }
    }).catch(function(err) {
        throw err;
    })
    data_file.push(d);
  }

  let data_f = [];
  d3.csv('static/assets/data/completedatabase-v6.csv').then(function(data) {
	//d3.csv('assets/data/completedatabase-v6.csv').then(function(data) {
    for(let j = 0; j<data.length; j++){
      data_f.push({
				i:j,
				Ref:data[j].Ref,
				Sample:data[j].Sample,
				Category1:data[j].Category1,
				Category2:data[j].Category2,
				//oxidos
				SiO2: (+data[j].SiO2).toFixed(4),
				TiO2: (+data[j].TiO2).toFixed(4),
				V2O5: (+data[j].V2O5).toFixed(4),
				Al2O3: (+data[j].Al2O3).toFixed(4),
				Cr2O3: (+data[j].Cr2O3).toFixed(4),
				Fe2O3: (+data[j].Fe2O3).toFixed(4),
				FeO: (+data[j].FeO).toFixed(4),
				MnO: (+data[j].MnO).toFixed(4),
				MgO: (+data[j].MgO).toFixed(4),
				ZnO: (+data[j].ZnO).toFixed(4),
				NiO: (+data[j].NiO).toFixed(4),
				//proyecciones
				Fe3: (+data[j].Fe3).toFixed(4),
				Fe2: (+data[j].Fe2).toFixed(4),
				//elementos
				Ti: (+data[j].Ti).toFixed(4),
				Al: (+data[j].Al).toFixed(4),
				Cr: (+data[j].Cr).toFixed(4),
				V: (+data[j].V).toFixed(4),
				Mn: (+data[j].Mn).toFixed(4),
				Mg: (+data[j].Mg).toFixed(4),
				Zn: (+data[j].Zn).toFixed(4),
				Ni: (+data[j].Ni).toFixed(4),
				Co: (+data[j].Co).toFixed(4),
				//miembros finals
				MgAl2O4: (+data[j].MgAl2O4).toFixed(6),
				FeAl2O4: (+data[j].FeAl2O4).toFixed(6),
				MgFe2O4: (+data[j].MgFe2O4).toFixed(6),
				FeFe2O4: (+data[j].FeFe2O4).toFixed(6),
				MgCr2O4: (+data[j].MgCr2O4).toFixed(6),
				FeCr2O4: (+data[j].FeCr2O4).toFixed(6),
				Mg2TiO4: (+data[j].Mg2TiO4).toFixed(6),
				Fe2TiO4: (+data[j].Fe2TiO4).toFixed(6),
      })
    }
  });

	var attributesOptions = [];
	var attributesLabels = ["Ti","Al","Cr","Fe3","Fe2","Mg",
	"TiO2","Al2O3","Cr2O3","Fe2O3","FeO","MgO",
	"MgAl2O4","FeAl2O4","MgFe2O4","FeFe2O4","MgCr2O4","FeCr2O4","Mg2TiO4","Fe2TiO4"];
	attributesLabels.forEach((item, i) => {
		attributesOptions.push(<Dropdown.Item key={"attr" + i} eventKey={"attr" + i}>{item}</Dropdown.Item>);
	});
	this.setState({attributesOptions:attributesOptions});
	this.setState({attributesLabels:attributesLabels});

  this.setState({complete_data:data_f});
  this.setState({umap_data:data_file});
}

handleOpen(){
	this.setState({show:true});
}

handleClose(){
	this.setState({show:false});

}

selectColorBy(evt){
	const options =  ["B&R Categories","Attribute"];
	this.setState({colorbyTitle:options[evt]});
}

selectColorByAttribute(evt){
	this.setState({colorbyAttributeTitle:this.state.attributesLabels[parseInt(evt.substr(4, 10))]});
	this.setState({selectedAttribute:evt.substr(4, 10)});
}

//Modifica el estado al seleccionar una opcion en dropdown
onSelect_dropdown(evt){
	const options = ["Cationes+Coc+Oxides","End Members"];
	this.setState({optionDropDown:evt});
	this.setState({titleDropDown:options[evt]});
	if(evt==0){
		this.setState({active:true})
	}
	else {
		this.setState({active:false})
	}
	this.setState({view_contours:false});
	this.deleteDetrital();
}

deleteDetrital(){
	document.getElementById('fileInput').value = '';
	this.setState({umap_detrital:[]});
	this.setState({detrital_data:[]});
	this.setState({filteredData_detrital:[]});
}

/*
* cbk- detritos seleccionados
*/
clkSeleccDetrital(detrital){
	let filteredData_detrital = this.state.filteredData_detrital;
	if(filteredData_detrital.includes(detrital)){ //Si el detrito ya esta seleccionado
		filteredData_detrital = filteredData_detrital.filter(item => item !== detrital);
	}
	else {
		filteredData_detrital.push(detrital);
	}
	this.setState({filteredData_detrital:filteredData_detrital});
}

update_filtered_detrital_data(data){
	this.setState({filteredData_detrital:data});
}

/*
* cbk - data seleccionados
*/
update_filteredData_panel(data){
  this.setState({filteredData_panel:data});
}

/*
* cbk - data seleccionados
*/
update_filteredData_umap(data){
  this.setState({filteredData_umap:data});
}

/*
* cbk - data seleccionados
*/
update_selecc_proj(data){
  this.setState({selecc_proj:data});
}

/*
* cbk - data resaltados
*/
update_filteredData_projection(data){
  this.setState({filteredData_projection:data});
}

update_labelsCategory(labels){
	this.setState({selecc_category:labels});
}

convertToArrayOfObjects(data) {
  var keys = data.shift(),
  	i = 0, k = 0,
    obj = null,
    output = [];

  for(i=0; i<data.length-1;i++){
  	obj = {};
		for (k = 0; k < keys.length; k++) {
    	obj[keys[k]] = data[i][k];
    }
		output.push(obj);
  }
	return output;
}

//Método para parsear el archivo subido por el usuario.
handleForce = dataHome => {
	//var data = this.convertToArrayOfObjects(dataHome);
	//this.setState({detrital_data:data});
	var collection = dataHome.slice(0,dataHome.length-1); // make a copy
	var keys = collection.shift();
	collection = collection.map(function (row) {
	    return keys.reduce(function (obj, key, i) {
	      obj[key] = row[i];
	      return obj;
	    }, {});
	});

	let detritos = [];
	let id = 0;
	let sample = "";
	for(let j = 0; j<collection.length; j++){
		if(isNaN(collection[j].id)) id = 0; else id =collection[j].id;
		if(collection[j].Sample == undefined) sample = ""; else sample = collection[j].Sample;
	   detritos.push({
			i:j,
			id:id,
			Ref:sample,
			umap1: +collection[j].umap1,
			umap2: +collection[j].umap2,
			Category:"User Input"
	    })
	 }
	this.setState({umap_detrital:detritos});

	let detrital_data = [];
	id = 0;
	sample = "";
	for(let j = 0; j<collection.length; j++){
		if(isNaN(collection[j].id)) id = 0; else id =collection[j].id;
		if(collection[j].Sample == undefined) sample = ""; else sample = collection[j].Sample;
		detrital_data.push({
			i:j,
			id:id,
			Sample:sample,
			//oxidos
			//SiO2: +(+collection[j].SiO2).toFixed(4),
			TiO2: +(+collection[j].TiO2).toFixed(4),
			//V2O5: +(+collection[j].V2O5).toFixed(4),
			Al2O3: +(+collection[j].Al2O3).toFixed(4),
			Cr2O3: +(+collection[j].Cr2O3).toFixed(4),
			Fe2O3: +(+collection[j].Fe2O3).toFixed(4),
			FeO: +(+collection[j].FeO).toFixed(4),
			//MnO: +(+collection[j].MnO).toFixed(4),
			MgO: +(+collection[j].MgO).toFixed(4),
			//ZnO: +(+collection[j].ZnO).toFixed(4),
			//NiO: +(+collection[j].NiO).toFixed(4),
			//proyecciones
		  Fe3: +(+collection[j]['Fe3+']).toFixed(4),
			Fe2: +(+collection[j]['Fe2+']).toFixed(4),
			//elementos
			Ti: +(+collection[j].Ti).toFixed(4),
			Al: +(+collection[j].Al).toFixed(4),
			Cr: +(+collection[j].Cr).toFixed(4),
			//V: +(+collection[j].V).toFixed(4),
			//Mn: +(+collection[j].Mn).toFixed(4),
			Mg: +(+collection[j].Mg).toFixed(4),
			//Zn: +(+collection[j].Zn).toFixed(4),
			//Ni: +(+collection[j].Ni).toFixed(4),
			//Co: +(+collection[j].Co).toFixed(4),
			//miembros finals
			MgAl2O4: +(+collection[j].MgAl2O4).toFixed(4),
			FeAl2O4: +(+collection[j].FeAl2O4).toFixed(4),
			MgFe2O4: +(+collection[j].MgFe2O4).toFixed(4),
			FeFe2O4: +(+collection[j].FeFe2O4).toFixed(4),
			MgCr2O4: +(+collection[j].MgCr2O4).toFixed(4),
			FeCr2O4: +(+collection[j].FeCr2O4).toFixed(4),
			Mg2TiO4: +(+collection[j].Mg2TiO4).toFixed(4),
			Fe2TiO4: +(+collection[j].Fe2TiO4).toFixed(4),
			//categorization %
			//miembros finals
			alaskanultramafic: Math.round(+(+collection[j]['ALASKAN ULTRAMAFIC']).toFixed(4)*100),
			alkalilamprophyres: Math.round(+(+collection[j]['ALKALI/LAMPROPHYRES']).toFixed(4)*100),
			basalt: Math.round(+(+collection[j]['BASALT']).toFixed(4)*100),
			komatiite: Math.round(+(+collection[j]['KOMATIITE']).toFixed(4)*100),
			layeredintrusion: Math.round(+(+collection[j]['LAYERED INTRUSION']).toFixed(4)*100),
			metamorphic: Math.round(+(+collection[j]['METAMORPHIC']).toFixed(4)*100),
			ophiolite: Math.round(+(+collection[j]['OPHIOLITE']).toFixed(4)*100),
			xenoliths: Math.round(+(+collection[j]['XENOLITHS']).toFixed(4)*100)
	  })
	 }
	this.setState({detrital_data:detrital_data});
	this.setState({filteredData_detrital:[]});
};

uploadDetritalData(collection){
	let detritos = [];
	let id = 0;
	let sample = "";
	for(let j = 0; j<collection.length; j++){
		if(isNaN(collection[j].id)) id = 0; else id =collection[j].id;
		if(collection[j].Sample == undefined) sample = ""; else sample = collection[j].Sample;
		 detritos.push({
			i:j,
			id:id,
			Ref:sample,
			umap1: +collection[j].umap1,
			umap2: +collection[j].umap2,
			Category:"User Input"
			})
	 }
	this.setState({umap_detrital:detritos});

	let detrital_data = [];
	id = 0;
	sample = "";
	for(let j = 0; j<collection.length; j++){
		if(isNaN(collection[j].id)) id = 0; else id =collection[j].id;
		if(collection[j].Sample == undefined) sample = ""; else sample = collection[j].Sample;
		detrital_data.push({
			i:j,
			id:id,
			Sample:sample,
			//oxidos
			//SiO2: +(+collection[j].SiO2).toFixed(4),
			TiO2: +(+collection[j].TiO2).toFixed(4),
			//V2O5: +(+collection[j].V2O5).toFixed(4),
			Al2O3: +(+collection[j].Al2O3).toFixed(4),
			Cr2O3: +(+collection[j].Cr2O3).toFixed(4),
			Fe2O3: +(+collection[j].Fe2O3).toFixed(4),
			FeO: +(+collection[j].FeO).toFixed(4),
			//MnO: +(+collection[j].MnO).toFixed(4),
			MgO: +(+collection[j].MgO).toFixed(4),
			//ZnO: +(+collection[j].ZnO).toFixed(4),
			//NiO: +(+collection[j].NiO).toFixed(4),
			//proyecciones
			Fe3: +(+collection[j]['Fe3+']).toFixed(4),
			Fe2: +(+collection[j]['Fe2+']).toFixed(4),
			//elementos
			Ti: +(+collection[j].Ti).toFixed(4),
			Al: +(+collection[j].Al).toFixed(4),
			Cr: +(+collection[j].Cr).toFixed(4),
			//V: +(+collection[j].V).toFixed(4),
			//Mn: +(+collection[j].Mn).toFixed(4),
			Mg: +(+collection[j].Mg).toFixed(4),
			//Zn: +(+collection[j].Zn).toFixed(4),
			//Ni: +(+collection[j].Ni).toFixed(4),
			//Co: +(+collection[j].Co).toFixed(4),
			//miembros finals
			MgAl2O4: +(+collection[j].MgAl2O4).toFixed(4),
			FeAl2O4: +(+collection[j].FeAl2O4).toFixed(4),
			MgFe2O4: +(+collection[j].MgFe2O4).toFixed(4),
			FeFe2O4: +(+collection[j].FeFe2O4).toFixed(4),
			MgCr2O4: +(+collection[j].MgCr2O4).toFixed(4),
			FeCr2O4: +(+collection[j].FeCr2O4).toFixed(4),
			Mg2TiO4: +(+collection[j].Mg2TiO4).toFixed(4),
			Fe2TiO4: +(+collection[j].Fe2TiO4).toFixed(4),
			//categorization %
			//miembros finals
			alaskanultramafic: Math.round(+(+collection[j]['ALASKAN ULTRAMAFIC']).toFixed(4)*100),
			alkalilamprophyres: Math.round(+(+collection[j]['ALKALI/LAMPROPHYRES']).toFixed(4)*100),
			basalt: Math.round(+(+collection[j]['BASALT']).toFixed(4)*100),
			komatiite: Math.round(+(+collection[j]['KOMATIITE']).toFixed(4)*100),
			layeredintrusion: Math.round(+(+collection[j]['LAYERED INTRUSION']).toFixed(4)*100),
			metamorphic: Math.round(+(+collection[j]['METAMORPHIC']).toFixed(4)*100),
			ophiolite: Math.round(+(+collection[j]['OPHIOLITE']).toFixed(4)*100),
			xenoliths: Math.round(+(+collection[j]['XENOLITHS']).toFixed(4)*100)
		})
	 }
	this.setState({detrital_data:detrital_data});
	this.setState({filteredData_detrital:[]});
}

uploadFile(){
	const apiUrl = 'https://icic.uns.edu.ar/geoviz/upload'; //Replace with your Flask API apiUrl
	//const apiUrl = 'http://192.168.20.37:8500/geoviz/upload'; //Replace with your Flask API apiUrl
	const paramName ='option';//Parameter name
	const paramValue = this.state.optionDropDown;
	const fileInput = document.getElementById('fileInput');

	const formData = new FormData();
	formData.append('file',fileInput.files[0]);
	formData.append(paramName,paramValue);

	d3.json(apiUrl,{
		method: 'POST',
		body: formData,
		credentials: "include", //comENTAR PARA VERSION LOCAL
	})
	.then(data =>{
		this.uploadDetritalData(data)
		this.setState({loading:false})

	})
	.catch(error =>{
		console.error('Error ',error);
	});
}
render(){

  var complete_data = this.state.complete_data;
	var umap_data = this.state.umap_data;
  var filteredData_panel =  this.state.filteredData_panel;
	var filteredData_umap =  this.state.filteredData_umap;
	var filteredData_projection =  this.state.filteredData_projection;
  var dropDownOption = this.state.dropDownOption;
	var umap_detrital = this.state.umap_detrital;
  let display = (this.state.umap_detrital.length>0)? "block" : "none";
	let displayColorBy = (this.state.colorbyTitle=="Attribute")? "block" : "none";
	let loading = this.state.loading;
  return(
    <div>
      //Navbar starts
      <header class="header">
        <div id="menu" class="fas fa-bars"></div>
          <nav class="navbar" >
            <ul>
              <li><a class="active" href="#dashboard">UMAP</a></li>
							<li><a href="#projections">Prism projections</a></li>
							<li><a href="#boxplot">Distribution</a></li>
              <li><a href="#traditional">Table</a></li>
            </ul>

          </nav>
      </header>
			<section id="dashboard" className="dashboard">
				<Container fluid style={{marginTop:"10vh"}}>
					<Row>
						<Col xs={2}>
						</Col>
						<Col xs={2}>

						</Col>
						<Col xs={5}>

						</Col>
						<Col xs={3}>
						<div class="contentCSVReader">
							<input type="file" id="fileInput" name="fileInput" required></input>
							<Button id="dropdown-basic-button" style={{width:"80px"}} onClick={()=>{this.setState({loading:true});this.uploadFile()}}>
							Upload
							</Button>
						</div>
						<Button variant="outline-dark" style={{border:"none"}} onClick={() => this.deleteDetrital()}>
								<FontAwesomeIcon icon={faTrash} />
						</Button>
						</Col>
					</Row>
					<Row style={{marginTop:"4vh",minHeight:"80vh"}}>

						<Col lg="2">
							<div class="card border-bottom-primary " style={{marginBottom:"2rem",height:"10rem"}}>
								<ListGroup>
			            <ListGroup.Item action href="#link1" onClick={(e)=>this.onSelect_dropdown(0)}>
			               Oxides, Cations and Ratios
			            </ListGroup.Item>
			            <ListGroup.Item action href="#link3" onClick={(e)=>this.onSelect_dropdown(1)}>
			              End Members
			            </ListGroup.Item>
									</ListGroup>
								</div>
								<div class="card border-primary  h-50 " style={{overflowY:"scroll"}}>
									<ConfigureComponent complete_data={complete_data} cbk_filteredData_panel={this.update_filteredData_panel} cbk_selecc_category={this.update_labelsCategory} cbk_detrital={this.cbk_detrital}
									cbk_filteredData_umap={this.update_filteredData_umap} cbk_filteredData_projection={this.update_filteredData_projection} dropDownOption={this.state.optionDropDown}
									filteredData_umap={filteredData_umap} filteredData_projection={filteredData_projection} cbk_dropDownOption={this.onSelect_dropdown}/>
								</div>
								<div class="card border-top-primary" style={{paddingTop:"2rem"}}>
									<div>
										Select attribute
										<DropdownButton id="dropdown-basic-button" title={this.state.colorbyAttributeTitle} onSelect={(e) => this.selectColorByAttribute(e)}>
			      					{this.state.attributesOptions}
		    						</DropdownButton>
									</div>
								</div>
								<div class="card border-primary" style={{marginTop:"2rem"}}>
									<Formfield>
										<Checkbox
											id="controlled-checkbox"
											checked={this.state.view_contours}
											onChange={e =>{this.setState({view_contours:!this.state.view_contours})} }
										/>
										<label for="controlled-checkbox">
											View categories contours
										</label>
								</Formfield>
								</div>
							</Col>


						<Col lg="6">
						 <UmapComponent view_contours={this.state.view_contours} optionDropDown={this.state.optionDropDown} umap_data={umap_data} complete_data={complete_data} filteredData_detrital={this.state.filteredData_detrital} selecc_category={this.state.selecc_category} umap_detrital={umap_detrital} filteredData_projection={filteredData_projection} filteredData_panel={filteredData_panel} filteredData_umap={filteredData_umap} cbk_filteredData_umap={this.update_filteredData_umap} cbk_filteredData_projection={this.update_filteredData_projection} clkSeleccDetrital={this.clkSeleccDetrital} cbk_filteredData_panel={this.update_filteredData_panel}
 							cbk_filtered_Data_detrital={this.update_filtered_detrital_data} cbk_dropDownOption={this.onSelect_dropdown} />

						</Col>
						<Col lg="4" style={{display:"block"}}>
							<Row>
								<UmapFocusComponent optionDropDown={this.state.optionDropDown} umap_data={umap_data} complete_data={complete_data} filteredData_detrital={this.state.filteredData_detrital} selecc_category={this.state.selecc_category} umap_detrital={umap_detrital} filteredData_projection={filteredData_projection} filteredData_panel={filteredData_panel} filteredData_umap={filteredData_umap} cbk_filteredData_umap={this.update_filteredData_umap} cbk_filteredData_projection={this.update_filteredData_projection} clkSeleccDetrital={this.clkSeleccDetrital} cbk_filteredData_panel={this.update_filteredData_panel}/>
							</Row>
							<Row>
								<UmapComponentColorBy style={{display:"block"}} optionDropDown={this.state.optionDropDown} umap_data={umap_data} complete_data={complete_data} filteredData_detrital={this.state.filteredData_detrital} selecc_category={this.state.selecc_category} umap_detrital={umap_detrital} filteredData_projection={filteredData_projection} filteredData_panel={filteredData_panel} filteredData_umap={filteredData_umap} cbk_filteredData_umap={this.update_filteredData_umap} cbk_filteredData_projection={this.update_filteredData_projection} clkSeleccDetrital={this.clkSeleccDetrital} cbk_filteredData_panel={this.update_filteredData_panel}
								colorBy={[this.state.colorbyTitle,this.state.attributesLabels[this.state.selectedAttribute]]}/>
							</Row>
						</Col>
					</Row>
	    	</Container>
      </section>
			{loading ? <div id="overlaydashboard" style={{backgroundColor:"rgba(0,0,0,0.3)"}}><Spinner animation="border" variant="dark" style={{position:"absolute",left:"50%",top:"10%",width:"100px",height:"100px"}}/></div>:<div></div>}
			<section class="projections" id="projections">
				<ProjectionsComponent complete_data={complete_data} detrital_data={this.state.detrital_data} filteredData_detrital={this.state.filteredData_detrital} filteredData_panel={filteredData_panel} filteredData_umap={filteredData_umap} filteredData_projection={filteredData_projection}
				cbk_filtered_Data_detrital={this.update_filtered_detrital_data} cbk_filteredData_projection={this.update_filteredData_projection} cbk_filteredData_umap={this.update_filteredData_umap} clkSeleccDetrital={this.clkSeleccDetrital}/>
			</section>
			<section class="boxplot" id="boxplot">
				<BoxplotComponent complete_data={complete_data} detrital_data={this.state.detrital_data} filteredData_detrital={this.state.filteredData_detrital} filteredData_panel={filteredData_panel} filteredData_umap={filteredData_umap} filteredData_projection={filteredData_projection}
				cbk_filtered_Data_detrital={this.update_filtered_detrital_data} cbk_filteredData_projection={this.update_filteredData_projection} cbk_filteredData_umap={this.update_filteredData_umap} clkSeleccDetrital={this.clkSeleccDetrital} colorBy={[this.state.colorbyTitle,this.state.attributesLabels[this.state.selectedAttribute]]}/>
			</section>
			<section class="traditional" id="traditional" style={{display:display}}>
				<h3> User Input Data </h3>
				<div class="row">
					<TableUserData  detrital_data={this.state.detrital_data} filteredData_detrital={this.state.filteredData_detrital} filteredData_umap={filteredData_umap}  clkSeleccDetrital={this.clkSeleccDetrital}/>
				</div>
			</section>
			<section class="traditional" id="traditional">
				<h3> Selected Data </h3>
				<div class="row">
					<TableComponent  complete_data={complete_data} detrital_data={this.state.detrital_data} filteredData_detrital={this.state.filteredData_detrital} filteredData_umap={filteredData_umap} selected_data={Array.from(new Set([...filteredData_projection, ...filteredData_umap]))} dropDownOption={dropDownOption} filteredData_projection={filteredData_projection} cbk_filteredData_projection={this.update_filteredData_projection}  cbk_filteredData_umap={this.update_filteredData_umap} clkSeleccDetrital={this.clkSeleccDetrital}/>
				</div>
      </section>
      <a href="#dashboard" aria-label="ScrollTop" class="fas fa-angle-up" id="scroll-top"></a>
    </div>
  );
}
}



/*						<ScatterMatrix complete_data={complete_data} filteredData_panel={filteredData_panel} />
 <StarplotComponent complete_data={complete_data} selected_data={selected_data} cbk_selected_data={this.update_selected_data}/>*/
